
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class MarketField extends Vue {
  val = '';

  formData: any = {
    marketId: '',
    marketName: '',
    subName: '',
  };

  @Prop()
  placeholder?: string;

  @Prop()
  refs!: any;

  @Model('change')
  value!: any;

  @Watch('formData', { immediate: true })
  watchInternalVal(): void {
    this.$emit('change', this.formData);
    this.$emit('updateSubmittable', true);

    // if (!this.val || this.val === '') {
    //   this.$emit('updateSubmittable', false);
    // } else {
    //   this.$emit('updateSubmittable', true);
    // }
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
      const { market_id, sub_name } = this.value;
      this.formData = {
        marketId: market_id || '',
        subName: sub_name || '',
      };
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
